exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control:disabled, .form-control[readonly]{\r\n    background-color: #eceeef !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/businesslogic/detail/detail-business-logic.component.css
// module id = ../../../../../src/app/private/businesslogic/detail/detail-business-logic.component.css
// module chunks = main